module.exports = __webpack_public_path__ + "img/logo-99@3x.051bf113.png";